import { shortDate } from '@/lib/format'
import { cn } from '@/lib/cn'
import type { CopyVersion } from '@/types'

/** Newest first. Selecting a version swaps the reading pane; the banner above it
 *  is what stops someone copying an old version by accident. */
export function CopyVersionList({
  history,
  currentVersion,
  viewing,
  onView,
}: {
  history: CopyVersion[]
  currentVersion: number
  viewing: number | null
  onView: (version: number) => void
}) {
  return (
    <div className="space-y-2 border-t border-rule pt-4">
      <h3 className="field-label">Version history</h3>
      <ul className="space-y-1">
        {[...history].reverse().map((v) => {
          const isCurrent = v.version === currentVersion
          const active = (viewing ?? currentVersion) === v.version
          return (
            <li key={v.version}>
              <button
                type="button"
                onClick={() => onView(v.version)}
                className={cn(
                  'flex w-full items-baseline gap-2 rounded-[4px] px-2 py-1 text-left text-[13px]',
                  active ? 'bg-brand-blue-50' : 'hover:bg-surface-sunk',
                )}
              >
                <span className="tabular font-head font-semibold">v{v.version}</span>
                <span className="text-ink-muted">{shortDate(v.savedAt)}</span>
                <span className="text-ink-faint">{v.author}</span>
                {isCurrent && <span className="ml-auto text-[11px] text-ink-faint">current</span>}
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
